import { all } from 'redux-saga/effects';
import stepShippingSagas from './StepShipping/sagas.js';

/**
 * Checkout root saga
 */ function* sagas() {
    yield all(stepShippingSagas);
}

export { sagas as default };
//# sourceMappingURL=sagas-registry.js.map
